import health_file_group from '@/api/module/health_file_group.js'
import { Dialog } from 'vant'
import store from "@/store/index"
const family = [
  {
    path: '/member-list',
    name: 'member-list',
    component: () => import(/* webpackChunkName: "memberList" */ '@/pages/family/member-list'),
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '健康监测'
      }
    }
  },
  {
    path: '/member-add',
    name: 'member-add',
    component: () => import(/* webpackChunkName: "memberAdd" */ '@/pages/family/member-add'),
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '新建成员'
      }
    }
  },
  {
    path: '/member-deal-invite-bind',
    name: 'member-deal-invite-bind',
    component: () => import(/* webpackChunkName: "memberDealInviteBind" */ '@/pages/family/member-deal-invite-bind'),
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '邀请处理'
      }
    }
  },
  // {
  //   path: '/member-deal-invite-bind/:id',
  //   name: 'member-deal-invite-bind',
  //   component: () => import(/* webpackChunkName: "memberDealInviteBind" */ '@/pages/family/member-deal-invite-bind'),
  //   meta: {
  //     title: '袋鼠健康',
  //     login: true,
  //     titleBar: {
  //       title: '邀请处理'
  //     }
  //   }
  // },
  {
    path: '/member-invite',
    name: 'member-invite',
    component: () => import(/* webpackChunkName: "memberInvite" */ '@/pages/family/member-invite'),
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '邀请成员'
      }
    }
  },
  {
    path: '/member-bind',
    name: 'member-bind',
    component: () => import(/* webpackChunkName: "memberBind" */ '@/pages/family/member-bind'),
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '成员绑定'
      }
    }
  },
  {
    path: '/member-invite-result',
    name: 'member-invite-result',
    component: () => import(/* webpackChunkName: "memberInviteResult" */ '@/pages/family/member-invite-result'),
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '邀请成员'
      }
    }
  },
  {
    path: '/member-invite-fail',
    name: 'member-invite-fail',
    component: () => import(/* webpackChunkName: "memberInviteFail" */ '@/pages/family/member-invite-fail'),
    meta: {
      title: '袋鼠健康',
      login: true,
      titleBar: {
        title: '邀请成员'
      }
    }
  },
  {
    path: '/group-list',
    name: 'group-list',
    component: () => import(/* webpackChunkName: "groupList" */ '@/pages/family/group-list'),
    meta: {
      title: '袋鼠健康',
      login: true
    }
  },

  // {
  //   path: '/family-list',
  //   name: 'family-list',
  //   component: () => import(/* webpackChunkName: "familylist" */ '@/pages/family/list'),
  //   meta: {
  //     login: true,
  //     titleBar: {
  //       title: '家庭成员',
  //       hasMenu: true
  //     }
  //   }
  // },
  {
    path: '/family-add',
    name: 'family-add',
    component: () => import(/* webpackChunkName: "familyadd" */ '@/pages/family/add'),
    meta: {
      login: true,
      titleBar: {
        title: '新建档案',
        hasMenu: true
      }
    }
  },
  {
    path: '/family-edit/:id',
    name: 'family-edit',
    component: () => import(/* webpackChunkName: "familyedit" */ '@/pages/family/member-edit'),
    meta: {
      login: true,
      titleBar: {
        title: '基础信息',
        hasMenu: true
      }
    }
  },
  {
    path: '/family-detail/:id',
    name: 'family-detail',
    component: () => import(/* webpackChunkName: "familydetail" */ '@/pages/family/detail2'),
    meta: {
      login: true,
      title: '袋鼠健康'
    }
  },
  {
    path: '/family-detail',
    name: 'family-detail-redirect',
    // component: () => import(/* webpackChunkName: "familydetail" */ '@/pages/family/detail2'),
    beforeEnter: (to, from, next) => {
      health_file_group.getBasicId().then((res) => {
        // 没有basic_id 手动去获取
        if (res.code === 200) {
          console.log('获取了 basic_id', from)
          console.log('location', location.href)
          // 测试环境团检跳转
          if ((!['home', 'mine'].includes(from.name) && location.href.includes('comefrom=')) || location.href.includes('redirect_flag_from=')) {
            let comefrom
            if (location.href.includes('comefrom=')) {
              comefrom = location.href.match(/comefrom=(.+)/)[1]
            } else {
              comefrom = location.href.match(/redirect_flag_from=(.+)/)[1]
            }
            window.sessionStorage.setItem('record-router-before-family', comefrom)
          }
          // 来自于旧域名重定向跳转
          // if (location.href.includes('redirect_origin_url')) {
          //   const originUrl = location.href.match(/redirect_origin_url=(.+)/)[1]
          //   next({ path: `/family-detail/${res.data[0].id}`, query: { redirect_origin_url: originUrl } })
          // } else {
          // }
          next({ path: `/family-detail/${res.data[0].id}`, replace: true })
        } else {

          store.state.userAgent !== 'pocketMiniapp' && store.state.userAgent !== 'wechatMiniapp' && Dialog({ message: '您尚未建立健康档案' })

        }
      })
    }
  },
  {
    path: '/family-base/:id',
    name: 'family-base',
    component: () => import(/* webpackChunkName: "familybaseinfo" */ '@/pages/family/base'),
    meta: {
      login: true,
      titleBar: {
        title: '基础数据',
        hasMenu: true
      }
    }
  },
  {
    path: '/blood-glucose/:id',
    name: 'blood-glucose',
    component: () => import(/* webpackChunkName: "bloodglucose" */ '@/pages/family/blood-glucose'),
    meta: {
      login: true,
      titleBar: {
        title: '血糖信息',
        hasMenu: true
      }
    }
  },
  {
    path: '/family-surgery/:id',
    name: 'family-surgery',
    component: () => import(/* webpackChunkName: "family-surgery" */ '@/pages/family/surgery'),
    meta: {
      login: true,
      titleBar: {
        title: '手术史',
        hasMenu: true
      }
    }
  },
  {
    path: '/blood-pressure/:id',
    name: 'blood-pressure',
    component: () => import(/* webpackChunkName: "bloodpressure" */ '@/pages/family/blood-pressure'),
    meta: {
      login: true,
      titleBar: {
        title: '血压信息',
        hasMenu: true
      }
    }
  },
  {
    path: '/add-temp/:id',
    name: 'add-temp',
    component: () => import(/* webpackChunkName: "addtemp" */ '@/pages/family/add-temp'),
    meta: {
      login: true,
      titleBar: {
        title: '体温信息',
        hasMenu: true
      }
    }
  },
  {
    path: '/add-acid/:id',
    name: 'add-acid',
    component: () => import(/* webpackChunkName: "addacid" */ '@/pages/family/add-acid'),
    meta: {
      login: true,
      titleBar: {
        title: '尿酸信息',
        hasMenu: true
      }
    }
  },
  {
    path: '/add-height/:id',
    name: 'add-height',
    component: () => import(/* webpackChunkName: "addheight" */ '@/pages/family/add-height'),
    meta: {
      login: true,
      titleBar: {
        title: '身高信息',
        hasMenu: true
      }
    }
  },
  {
    path: '/add-weight/:id',
    name: 'add-weight',
    component: () => import(/* webpackChunkName: "addweight" */ '@/pages/family/add-weight'),
    meta: {
      login: true,
      titleBar: {
        title: '体重信息',
        hasMenu: true
      }
    }
  }
]

export default family
